import { createFileRoute, redirect } from '@tanstack/react-router';

import { meQueryOptions } from '../../api/me';

// Role-aware landing: operators live in the bulk-upload flow, everyone else
// starts on their own page. A failure to read `me` leaves no oid to redirect
// to, so it falls through to `/photos/me`, which redirects on its own once the
// query succeeds — and whose `_auth` loader handles the 401/403 → /login dance.
export const Route = createFileRoute('/_auth/')({
  beforeLoad: async ({ context }) => {
    let me: { oid: string; role: string | null };
    try {
      me = await context.queryClient.query({
        ...meQueryOptions(),
        staleTime: 'static',
      });
    } catch {
      throw redirect({ to: '/photos/me' });
    }
    if (me.role === 'operator') {
      throw redirect({ to: '/operations' });
    }
    throw redirect({ to: '/users/$oid', params: { oid: me.oid } });
  },
});
